import { ref as m, computed as g, watch as v, resolveComponent as r, openBlock as u, createBlock as d, withCtx as f, createVNode as h, createTextVNode as _, createElementVNode as p, createCommentVNode as B } from "vue";
/* empty css                    */
import y from "./design-system.es128.js";
import k from "./design-system.es37.js";
import C from "./design-system.es62.js";
/* empty css                    */
import N from "./design-system.es58.js";
/* empty css                    */
/* empty css                    */
/* empty css                    */
import S from "./design-system.es59.js";
/* empty css                    */
/* empty css                    */
import { useMenu as V } from "./design-system.es293.js";
import M from "./design-system.es116.js";
/* empty css                    */
/* empty css                    */
const b = {
  name: "DsMenuSearchHeader",
  components: {
    Box: k,
    Inline: C,
    Icon: N,
    IconButton: S
  },
  props: {
    search: { type: String, default: "" },
    placeholder: { type: String, default: "Search" }
  },
  emits: ["update:search"],
  setup(c, { emit: e }) {
    const o = m(null), t = m(null), { registerSearchHeader: n } = V(), { t: i } = M(), a = g(() => c.placeholder || i("menu.search"));
    function s() {
      t.value.focus(), e("update:search", "");
    }
    return v(o, (l) => {
      n == null || n(l);
    }), {
      el: o,
      input: t,
      placeholderLabel: a,
      clear: s
    };
  }
}, w = { style: { flex: "1" } }, D = ["value", "placeholder"], L = { style: { margin: "calc(-1 * var(--ds-spacing-050))" } };
function E(c, e, o, t, n, i) {
  const a = r("Icon"), s = r("IconButton"), l = r("Inline"), I = r("Box");
  return u(), d(I, {
    ref: "el",
    "padding-y": "spacing-150",
    "padding-x": "spacing-150",
    class: "ds-menu-search"
  }, {
    default: f(() => [
      h(l, {
        fill: "",
        space: "spacing-100",
        "align-y": "center"
      }, {
        default: f(() => [
          h(a, { name: "search" }),
          e[1] || (e[1] = _()),
          p("div", w, [
            p("input", {
              ref: "input",
              value: o.search,
              type: "search",
              placeholder: t.placeholderLabel,
              class: "ds-menu-search-input",
              onInput: e[0] || (e[0] = (x) => c.$emit("update:search", x.target.value))
            }, null, 40, D)
          ]),
          e[2] || (e[2] = _()),
          p("div", L, [
            o.search ? (u(), d(s, {
              key: 0,
              name: "x-circle-fill",
              dense: "",
              class: "ds-menu-search-clear-icon",
              onClick: t.clear
            }, null, 8, ["onClick"])) : B("", !0)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512);
}
const X = /* @__PURE__ */ y(b, [["render", E], ["__scopeId", "data-v-0ea466e8"]]);
export {
  X as default
};
//# sourceMappingURL=design-system.es77.js.map
